export default function Avatar(props) {
  return (
    <svg x='0px' y='0px' viewBox='0 0 180 180' {...props}>
      <circle fill='#cdd2e6' cx='90.1' cy='90' r='90' />
      <path
        fill='#e9ecf1'
        d='M90.1,0c-12-0.1-23.9,2.3-35,7.1C33.6,16.2,16.4,33.4,7.2,55C2.5,66,0.1,77.9,0.2,89.9
    c-0.1,12.1,2.3,24,7.1,35.1c9.2,21.6,26.4,38.8,47.9,47.9c11.1,4.7,23,7.1,35,7.1c12,0.1,23.9-2.3,35-7.1
    c21.6-9.1,38.8-26.3,47.9-47.9c4.7-11.1,7.2-23.1,7.1-35.1c0.1-12-2.3-23.9-7.1-34.9c-9.2-21.6-26.4-38.8-47.9-47.9
    C114.1,2.3,102.2-0.1,90.1,0z M144.3,137.4c-5.9-8.8-13.7-16.1-23-21.3c-9.5-5.4-20.3-8.1-31.2-8c-10.9-0.1-21.7,2.6-31.2,8
    c-9.2,5.2-17,12.5-22.8,21.3c-5.6-6.4-10.1-13.7-13.2-21.6c-6.6-17.4-6.3-36.6,0.8-53.8c3.6-8.6,8.8-16.3,15.4-22.9
    c6.6-6.5,14.4-11.7,22.9-15.4c8.8-3.8,18.4-5.8,28-5.7c9.6-0.1,19.2,1.9,28,5.7c8.5,3.7,16.3,8.9,22.9,15.4
    c13.5,13.5,21,31.8,21,50.9c0.1,8.8-1.6,17.6-4.7,25.8C154.2,123.6,149.8,131,144.3,137.4z M116.9,72c0-14.9-12.1-27-27-27
    C75,45,63,57.1,63,72c0,14.9,12.1,27,27,27C104.8,99,116.9,86.9,116.9,72L116.9,72z'
      />
    </svg>
  )
}
